import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

export function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange, onRowsPerPageChange = () => {} } = props;
  
    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 1);
    };
  
    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };
  
    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };
  
    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage)));
    };
  
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px', alignItems: 'center' }}>
          <span style={{ color: 'white', fontSize: '14px' }}>Showing {(((page - 1) * rowsPerPage) + 1)} to {(page * rowsPerPage)} of {count} entries</span>
          <div>
          <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
            <InputLabel id="rows-per-page-label" sx={{ color: 'white' }}>Rows</InputLabel>
            <Select
              labelId="rows-per-page-label"
              id="rows-per-page-select"
              value={rowsPerPage}
              onChange={(event) => {
                // This handler assumes 'onRowsPerPageChange' is passed as a prop to TablePaginationActions.
                // Please ensure 'onRowsPerPageChange' is available in the 'props' object.
                // For example, by adding it to the destructuring:
                // const { count, page, rowsPerPage, onPageChange, onRowsPerPageChange } = props;
                onRowsPerPageChange(event, parseInt(event.target.value, 10));
              }}
              label="Rows"
              sx={{ color: 'white', '.MuiSvgIcon-root': { color: 'white' } }}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={25}>25</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
          <IconButton
            onClick={handleFirstPageButtonClick}
            disabled={page === 1}
            aria-label="first page"
          >
            {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
          </IconButton>
          <IconButton
            onClick={handleBackButtonClick}
            disabled={page === 1}
            aria-label="previous page"
          >
            {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
          </IconButton>
          <IconButton
            onClick={handleNextButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage)}
            aria-label="next page"
          >
            {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
          </IconButton>
          <IconButton
            onClick={handleLastPageButtonClick}
            disabled={page >= Math.ceil(count / rowsPerPage)}
            aria-label="last page"
          >
            {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
          </IconButton>
          </div>
        </div>
      </Box>
    );
  }